import arrowBackIcon from './arrow_back.svg'

export {
  arrowBackIcon
}
